// extracted by mini-css-extract-plugin
export default {"field":"CreateOrganization_field__WWtRe","label":"CreateOrganization_label__G4HXI"};